var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventCheckIn = function SvgEventCheckIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 16.668H15a1.667 1.667 0 0 0 1.666-1.667v-2.5a.833.833 0 0 1 1.667 0v2.5a3.333 3.333 0 0 1-3.334 3.334H5A3.333 3.333 0 0 1 1.666 15v-2.5a.833.833 0 0 1 1.667 0v2.5a1.667 1.667 0 0 0 1.666 1.667h2.5a.834.834 0 0 1 0 1.667h5a.834.834 0 0 1 0-1.667M3.332 7.501a.833.833 0 1 1-1.667 0v-2.5a3.333 3.333 0 0 1 3.333-3.333h2.5a.833.833 0 0 1 0 1.667H5A1.667 1.667 0 0 0 3.333 5zm13.333 0v-2.5a1.667 1.667 0 0 0-1.667-1.666h-2.5a.833.833 0 0 1 0-1.667H15a3.334 3.334 0 0 1 3.334 3.333v2.5a.833.833 0 1 1-1.667 0"
  })));
};
export default SvgEventCheckIn;